import React from "react"
import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import { GameProvider } from "./src/context/gameContext"
import theme from "./src/theme"

import "react-alice-carousel/lib/alice-carousel.css"
import "./src/style/globalStyle.css"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GameProvider>{element}</GameProvider>
  </ThemeProvider>
)
